import LocationSelect, {
  type LocationOption,
} from "@/components/form/location-select";
import {
  makePickerField,
  type PickerFieldProps,
} from "@/fields/_internal/make-picker-field";

/** **Value is the whole market object**, not its id. */
export type LocationFieldProps = PickerFieldProps<LocationOption | null>;

export const LocationField = makePickerField<LocationOption | null>({
  name: "LocationField",
  control: LocationSelect,
  popout: true,
});
